// Footer chrome: estimate total + disclaimer.

import type { SharePayload } from "../types.ts";

const USD = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

export function renderFooter(payload: SharePayload): HTMLElement {
  const footer = document.createElement("footer");
  footer.className = "dm-footer";

  if (payload.totalCents > 0) {
    const total = document.createElement("div");
    total.className = "dm-footer__total";

    const label = document.createElement("span");
    label.className = "dm-footer__label";
    label.textContent = "Estimated total";

    const amount = document.createElement("span");
    amount.className = "dm-footer__amount";
    amount.setAttribute("data-testid", "dm-total");
    amount.textContent = USD.format(payload.totalCents / 100);

    total.append(label, amount);
    footer.appendChild(total);
  }

  if (payload.acceptedDisclaimer) {
    const disclaimer = document.createElement("p");
    disclaimer.className = "dm-footer__disclaimer";
    disclaimer.textContent = payload.acceptedDisclaimer;
    footer.appendChild(disclaimer);
  }

  return footer;
}
